import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MaterialModule } from '../../../../material/material.module';
import { CommonModule } from '@angular/common';
import { map, Observable, startWith } from 'rxjs';
import { CuentasBancarias } from '../ctas';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '../../../../settings/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BankCatalogService, Banco, Cuenta } from '../../bank-catalog.service';

@Component({
  selector: 'app-crear-cuenta-bancaria',
  standalone: true,
  imports: [MaterialModule, CommonModule, ReactiveFormsModule, FormsModule,],
  templateUrl: './crear-cuenta-bancaria.component.html',
  styleUrl: './crear-cuenta-bancaria.component.less'
})
export class CrearCuentaBancariaComponent implements OnInit {

  public info!: CuentasBancarias;
  run:string="";
  full_name:string="";
  dialog_open:boolean=false;


  @Input() load_data:any;

  parent:any;

  @Input() id_company:any;
  @Output() funciones = new EventEmitter<number>();

  disabledButton:boolean= false;
  showSpinner:boolean = false;

  bancos: Banco[] = [];
  
  cuentas: Cuenta[] = [];

  valForm: FormGroup;

  is_tercero: boolean= false;

  email:any;

  public dialogRef!:MatDialogRef<CrearCuentaBancariaComponent>

  //autocomplete select
  myControl = new FormControl();
  filteredOptions!: Observable<Banco[]>;
  bank_selected: any;

  constructor(
    fb: FormBuilder,
    public snackBar: MatSnackBar,
    public settings: SettingsService,
    private bankCatalog: BankCatalogService
  ) {
      let rutValid = new FormControl(null, Validators.compose([Validators.required, Validators.pattern('^[0-9]{7,10}[-][0-9K]$')]));
      // let accMail = new FormControl (null, Validators.compose([Validators.required, Validators.pattern('[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{1,5}')]));
      let accNumber = new FormControl(null, Validators.compose([Validators.required, Validators.pattern('^[0-9]{4,12}$')]));

      this.valForm = fb.group({
          'bank': ['', Validators.compose([Validators.required])],
          'type': ['', Validators.compose([Validators.required])],
          'rut': rutValid,
          'number': accNumber,
          'name': ['', Validators.compose([Validators.required])],
          'tercero': new FormControl(''),
          'email': new FormControl('')

        });
        this.valForm.controls["tercero"].setValue(false);
  }

  async submitForm($ev:any, value: any) {

      console.log(value);
      $ev.preventDefault();

      for (let c in this.valForm.controls) {
          this.valForm.controls[c].markAsTouched();
      }
  
      if (this.valForm.valid) {
          try {
            const formData = {
              bank: value.bank,
              type: value.type,
              name: value.name,
              number: value.number,
              tercero: value.tercero,
              rut: value.rut,
              email: value.email,
              company_id: this.id_company || null,
            };
            console.log('formData', formData);

              const bd: any = await this.settings.get_query(2,  '/cliente-inversionista/bank-accounts/', formData);
              var body_data: any =bd._body;
              switch (bd.status) {
                case 200:
        
                this.disabledButton = false;
                this.showSpinner = false;

                let sb = this.snackBar.open("¡Cuenta agregada!", "Aceptar", {
                    duration: 20000,
                    panelClass: "simpli-snack"
                });

                //this.info.reloadAccounts();

                if(this.dialog_open == true){
                    this.parent.post_facturas()
                }else{
                    this.funciones.emit(1)
                }

                if (this.dialogRef) {
                    this.dialogRef.close(true);
                } else {
                    this.valForm.reset();
                    this.valForm.controls["tercero"].setValue(false);
                }
        
                  break;
                default:
        
                  break;
              }
            } catch (bd: any) {
        
            }
      }

    }

  filtrar_banco($e:any){
      this.bank_selected = $e.id
      console.log("algo del filtar",$e.id);
      let cuenta = {id: "2", name: "Cuenta RUT"}
      if (this.bank_selected != "26"){
          if (this.cuentas.indexOf(cuenta) != -1) {
              this.cuentas.splice(this.cuentas.indexOf(cuenta), 1);
          }
      } else {
          this.cuentas.push(cuenta)
      }
  }

  ngOnInit()
  {

      // this.get_personal_data();
      this.load_bancos();
      this.load_cuentas();
  }

  async load_bancos() {
      try {
        this.bancos = await this.bankCatalog.getBancos();
        this.filteredOptions = this.valForm.controls["bank"].valueChanges
        .pipe(
            startWith(''),
            map((value:any) => typeof value === 'string' ? value : value.name),
            map((name:any) =>  name ? this._filter(name) : this.bancos.slice())
        );
      } catch (error) {
        console.error('Error al cargar bancos:', error);
      }
    }

  // displayFn(bancos) {
  //     return bancos && bancos.name ? bancos.name : '';
  //   }

    private _filter(name: string): Banco[] {
      const filterValue = name.toLowerCase();
  
      return this.bancos.filter(option => option.name.toLowerCase().includes(filterValue) === true);
    }

    async load_cuentas() {
      try {
        const allCuentas = await this.bankCatalog.getCuentas();
        this.cuentas = allCuentas.filter((_: any, i: number) => i !== 1);
      } catch (error) {
        console.error('Error al cargar tipos de cuenta:', error);
      }
    }

  //cambiar por la información de la empresa

  async get_personal_data() {
      try {
        const bd: any = await this.settings.get_query(1, '/cliente-inversionista/company/' + this.id_company + "/");
        var body_data: any =bd._body;
        switch (bd.status) {
          case 200:
  

          this.full_name = body_data.company.business_name;
          if(this.load_data == false){
            console.log("false")
          }else{
            this.valForm.controls['rut'].setValue(body_data.company.rut);
            this.valForm.controls['name'].setValue(this.full_name);
            this.run = body_data.company.rut  
          }
  
            break;
          default:
  
            break;
        }
      } catch (bd: any) {
  
      }
    }

  change_run()
  {
    let st = this.run.replace("-", "");
    let arr = st.split("");
    let st_out = "";

    for (let i=0; i < arr.length; i++)
    {
      st_out = st_out + arr[i];

      if (i == arr.length - 2)
      {
        st_out = st_out + "-"
      }
    }

    this.run=st_out;
  }
}